// extracted by mini-css-extract-plugin
module.exports = {"primary":"#102537","secondary":"#d3e6f7","warning":"#e9ab05","success":"#0abb59","error":"#e7201b","light-grey":"#f7f7f7","dark":"#272727","grey":"#e3e3e3","neutral":"#1d56d8"};